<template>
  <List :mapState="'inventoryProviders'" :allDispatch="'inventoryProvidersAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/inventory/providers/list.vue